import React, { useEffect, useState } from 'react';
import MyScore from '../../Profile/Scores';
import ScoreBox from './ScoresBox';
import Popup from '../../Common/Popup';
import { base_url } from '../../Api/Api';
import Skltn from './skltnScore';
import Chart from './chart';

const Scores = (props) => {

    const [progress, setProgress] = useState(0);
    const [state, setState] = useState({
        data: null,
        duration: '',
        loader: true,
        starsFull: [],
        starsEmpity: [],
        popupStatus: false
    })
    const [scoreList, setScoreList] = useState({
        dataEarn: [],
        dataLose: []
    })

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`user_panel`)
            .then(response => {
                let starsFull = [];
                let starsEmpity = []
                for (let i = 1; i <= 5; i++) {
                    response.data.userStar >= i ?
                        starsFull.push(i) //response.data.userStar 
                        :
                        starsEmpity.push(i)
                }
                setState({
                    ...state,
                    data: response.data,
                    loader: false,
                    starsFull: starsFull,
                    starsEmpity: starsEmpity
                })
                setScoreList({
                    ...scoreList,
                    dataEarn: response.data.plus_scores_data,
                    dataLose: response.data.minus_scores_data
                })
                setProgress((response.data.totalScores * 100) / response.data.max_score);
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])

    const togglePopup = () => {
        setState({
            ...state,
            popupStatus: !state.popupStatus
        })
    }

    return (
        <div className="scores">
            <div className="contain">
                <div className="scores-body">
                    <Popup
                        active={state.popupStatus}>
                        {state.data == null ? null :
                            <>
                                <i className="icon-close" onClick={togglePopup}></i>
                                <span className="userLevel">جزئیات سطح کاربری</span>
                                {state.data.info.levels.map((info, index) =>
                                    <div className="level" key={index}>
                                        <span>{info.title}</span>
                                        <span>{info.score_description}</span>
                                        <p>{info.description}</p>
                                    </div>
                                )}
                            </>
                        }
                    </Popup>
                    {state.data == null ?
                        <Skltn />
                        :
                        <div className="details">
                            <div className="awarded">
                                <div className="MyScores">
                                    {state.data == null ? null :
                                        <MyScore
                                            progress={progress}
                                            data={state.data} />
                                    }
                                </div>
                                <div className="rating">
                                    <span>سطح کاربری : <b>{state.data == null ? '' : state.data.userLevel} <i
                                        className="icon-exclamation"
                                        onClick={togglePopup} ></i></b></span>
                                    <div className="stars">
                                        {state.starsEmpity.map(item =>
                                            <i className="icon-favourite1"></i>
                                        )}
                                        {state.starsFull.map(item =>
                                            <i className="icon-favourites-filled-star-symbol"></i>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <Chart
                                data={state.data} />
                        </div>
                    }
                    {state.data == null ?
                        <Skltn />
                        :
                        <div className="getScores">
                            <div className="get">
                                <span>امتیازات کسب شده</span>
                                <ScoreBox
                                    data={scoreList.dataEarn.length == 0 ? [] : scoreList.dataEarn}
                                    lose={false} />
                            </div>
                            <div className="get">
                                <span>امتیازات خرج شده</span>
                                <ScoreBox
                                    data={scoreList.dataLose}
                                    lose={true} />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Scores;

// import React, { useEffect, useState } from 'react';
// import Button from '@material-ui/core/Button';
// import { curveCatmullRom } from 'd3-shape';
// import { XYPlot, XAxis, YAxis, HorizontalGridLines, VerticalGridLines, LineSeries } from 'react-vis';
// import MyScore from '../../Profile/Scores';
// import ScoreBox from './ScoresBox';
// import Popup from '../../Common/Popup';
// import { base_url } from '../../Api/Api';
// import Skltn from './skltnScore';

// const Scores = (props) => {

//     const [value, setValue] = useState(2);

//     const [progress, setProgress] = useState(0);
//     const [state, setState] = useState({
//         data: null,
//         duration: '',
//         chartData: 'weekly',
//         loader: true,
//         starsFull: [],
//         starsEmpity: [],
//         popupStatus: false
//     })
//     const [scoreList, setScoreList] = useState({
//         dataEarn: [],
//         dataLose: []
//     })

//     useEffect(() => {

//         window.scrollTo(0, 0)
//         const headers = {
//             "Authorization": cookies.get("api_key"),
//             "content-type": "application/json",
//         };
//         base_url.get(`user_panel`, {
//             
//         })
//             .then(response => {
//                 let starsFull = [];
//                 let starsEmpity = []
//                 for (let i = 0; i < 5; i++) {
//                     response.data.userStar >= i ?
//                         starsFull.push(i) //response.data.userStar
//                         :
//                         starsEmpity.push(i)
//                 }
//                 setState({
//                     ...state,
//                     data: response.data,
//                     loader: false,
//                     starsFull: starsFull,
//                     starsEmpity: starsEmpity
//                 })
//                 setScoreList({
//                     ...scoreList,
//                     dataEarn: response.data.plus_scores_data,
//                     dataLose: response.data.minus_scores_data
//                 })
//                 setTimeout(() => {
//                     setProgress((response.data.totalScores * 100) / response.data.max_score);
//                 }, 400);
//             })
//             .catch(error => {
//                 if (error.response != undefined) {
//                     if (error.response.status == 401) {
//                         props.history.push(`/Entrance`)
//                     }
//                 }
//             })

//     }, [])

//     const togglePopup = () => {
//         setState({
//             ...state,
//             popupStatus: !state.popupStatus
//         })
//     }

//     const changeChartData = (target) => {
//         setState({
//             ...state,
//             chartData: target
//         })
//     }

//     return (
//         <div className="scores">
//             <div className="contain">
//                 <div className="scores-body">
//                     <Popup
//                         active={state.popupStatus}>
//                         {state.data == null ? null :
//                             <>
//                                 <i className="icon-close" onClick={togglePopup}></i>
//                                 <span className="userLevel">جزئیات سطح کاربری</span>
//                                 {state.data.info.levels.map((info, index) =>
//                                     <div className="level" key={index}>
//                                         <span>{info.title}</span>
//                                         <span>{info.score_description}</span>
//                                         <p>{info.description}</p>
//                                     </div>
//                                 )}
//                             </>
//                         }
//                     </Popup>
//                     {state.data == null ?
//                         <Skltn />
//                         :
//                         <div className="details">
//                             <div className="awarded">
//                                 <div className="MyScores">
//                                     {state.data == null ? null :
//                                         <MyScore
//                                             progress={progress}
//                                             data={state.data} />
//                                     }
//                                 </div>
//                                 <div className="rating">
//                                     <span>سطح کاربری : <b>متوسط <i
//                                         className="icon-exclamation"
//                                         onClick={togglePopup} ></i></b></span>
//                                     <div className="stars">
//                                         {state.starsFull.map(item =>
//                                             <i className="icon-favourite1"></i>
//                                         )}
//                                         {state.starsEmpity.map(item =>
//                                             <i className="icon-favourites-filled-star-symbol"></i>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="chart">
//                                 <div className="row-btns">
//                                     <div className={`btn-tiem ${state.chartData == 'weekly' ? 'active' : ''}`}>
//                                         <Button
//                                             variant="contained"
//                                             onClick={() => changeChartData('weekly')} >هفتگی</Button>
//                                     </div>
//                                     <div className={`btn-tiem ${state.chartData == 'monthly' ? 'active' : ''}`}>
//                                         <Button
//                                             variant="contained"
//                                             onClick={() => changeChartData('monthly')} >ماهانه</Button>
//                                     </div>
//                                     <div className={`btn-tiem ${state.chartData == 'annual' ? 'active' : ''}`}>
//                                         <Button
//                                             variant="contained"
//                                             onClick={() => changeChartData('annual')} >سالانه</Button>
//                                     </div>
//                                 </div>
//                                 {state.data == null ? null :
//                                     <XYPlot
//                                         width={560}
//                                         height={300}
//                                         xType="ordinal"
//                                         animation
//                                     >
//                                         <HorizontalGridLines
//                                             // tickTotal={4}
//                                             style={{ stroke: '#ddd' }} />
//                                         <XAxis
//                                             title=""
//                                             style={{
//                                                 line: { stroke: '#ddd' },
//                                                 ticks: { stroke: '#ddd' },
//                                                 text: { stroke: 'none', fill: '#6b6b76', fontWeight: 400, fontSize: 14 }
//                                             }}
//                                         />
//                                         <YAxis
//                                             title=""
//                                             // tickTotal={4}
//                                             style={{
//                                                 line: { stroke: '#ddd' },
//                                                 ticks: { stroke: '#ddd' },
//                                                 text: { stroke: 'none', fill: '#6b6b76', fontWeight: 400, fontSize: 14 }
//                                             }} />
//                                         <LineSeries
//                                             className="first-series"
//                                             style={{ stroke: '#152b9f' }}
//                                             curve={curveCatmullRom.alpha(0.5)}
//                                             // data={[{ x: "aaa", y: 0 }, { x: "bbb", y: 11 }, { x: "ccc", y: 29 }]}
//                                             data={state.data.chart[state.chartData].map(info => {
//                                                 return { x: info.name, y: info.earn }
//                                             })}
//                                         />
//                                         <LineSeries
//                                             className="third-series"
//                                             style={{ stroke: '#ff4337' }}
//                                             curve={curveCatmullRom.alpha(0.5)}
//                                             // data={[{ x: "aaa", y: 0 }, { x: "bbb", y: 13 }, { x: "ccc", y: 32 }]}
//                                             data={state.data.chart[state.chartData].map(info => {
//                                                 return { x: info.name, y: info.lose }
//                                             })}
//                                         />
//                                     </XYPlot>
//                                 }

//                             </div>
//                         </div>
//                     }
//                     {state.data == null ?
//                         <Skltn />
//                         :
//                         <div className="getScores">
//                             <div className="get">
//                                 {scoreList.dataEarn.length == 0 ? null :
//                                     <>
//                                         <span>امتیازات کسب شده</span>
//                                         <ScoreBox
//                                             data={scoreList.dataEarn.length == 0 ? [] : scoreList.dataEarn}
//                                             lose={false} />
//                                     </>
//                                 }
//                             </div>
//                             <div className="get">
//                                 {scoreList.dataLose.length == 0 ? null :
//                                     <>
//                                         <span>امتیازات خرج شده</span>
//                                         <ScoreBox
//                                             data={scoreList.dataLose}
//                                             lose={true} />
//                                     </>
//                                 }
//                             </div>
//                         </div>
//                     }
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Scores;